// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"Page_animate-height__YC7Pi","Page":"Page_Page__3bGiQ","Title":"Page_Title__22KiO","animateHeight":"Page_animateHeight__2HVPD"};